// eslint-disable-next-line import/no-anonymous-default-export
export default {
  sessionExpired: 'Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.',
  loginRequired: 'Bu sayfaya erişmek için giriş yapmalısınız.',
  unauthorized: 'Bu işlem için yetkiniz yok.',
  loginSuccess: 'Giriş başarılı',
  logoutSuccess: 'Çıkış başarılı',
  logout: 'Çıkış Yap'
};
